export const MATTER_EVENT_CATEGORY_OPTIONS = [
  { value: "matter", label: "Matter" },
  { value: "incident_report", label: "Incident report" },
  { value: "matter_email", label: "Email" },
  { value: "matter_expense", label: "Expense" },
  { value: "matter_file", label: "File" },
  { value: "matter_insurance", label: "Insurance" },
  { value: "matter_lien", label: "Lien" },
  { value: "matter_litigation_date", label: "Litigation date" },
  { value: "matter_lost_wages", label: "Lost wages" },
  { value: "matter_note", label: "Note" },
  { value: "matter_property_damage", label: "Property damage" },
  { value: "matter_settlement_counter", label: "Settlement counter" },
  { value: "matter_settlement_demand", label: "Settlement demand" },
  { value: "matter_settlement_offer", label: "Settlement offer" },
  { value: "matter_task", label: "Task" },
  { value: "matter_trust_check", label: "Trust check" },
  { value: "matter_vehicle", label: "Vehicle" },
  { value: "medical_treatment", label: "Medical treatment" },
  { value: "medical_treatment_appointment", label: "Medical appointment" },
  {
    value: "medical_treatment_balance_confirmation",
    label: "Medical balance confirmation",
  },
  { value: "medical_treatment_bill", label: "Medical bill" },
  { value: "medical_treatment_plan", label: "Medical treatment plan" },
  { value: "medical_treatment_record", label: "Medical record" },
] as const;

export type MatterEventCategory =
  (typeof MATTER_EVENT_CATEGORY_OPTIONS)[number]["value"];
